import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.js';
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

class Services extends React.Component {

    render() {
        return (

            <div className="container  black_bg left-align">
                <Container>

                    <Row>
                        <Col>
                            <br/><br/>
                            For every artists there comes a time when the artistic vision and passions meet
                            the cold unemotional world of business. Do you want an attorney who just added
                            ‘entertainment lawyer’ to their long list of practice areas? Hire an attorney
                            who’s been in your shoes and who can use that experience to look out for your
                            best interest.

                            <br/><br/>

                            We know many new to the business are reluctant to hire an attorney or are afraid
                            the cost will be too high. We understand the reality of the current economy and
                            its effect on prospective clients. In most cases, Q Entertainment Law offers
                            affordable flat rate pricing. The more services you need, the lower each will
                            cost. You’ll know what you’ll spend and exactly what you spent it on.

                            <br/><br/>

                            Have a question? It’s always free to ask. Contact us.
                            <br/><br/><br/><br/>

                            <u>NEW BAND PACKAGE:</u>
                            $900. Flat.
                            <br/><br/>
                            Includes:
                            <ul>
                                <li>Negotiating and drafting a Band Agreement</li>
                                <li>A Sample Performance Agreement for use with every booking</li>
                                <li>Copyrighting your latest Album for both the song writing and the sound
                                    recording.</li>
                            </ul>
                            <br/><br/>

                            <u>Common Services Offered (list not exhaustive):</u>
                            <br/><br/>
                            <ul>
                                <li>
                                    Intellectual Property Registration</li>
                                <li>Business Formation and Operating Agreements (Band Agreements)</li>
                                <li>Recording Contracts/Music Publishing Agreements</li>
                                <li>Mediation/Alternative Dispute Resolution</li>
                                <li>Performance/Appearance Agreements and Riders</li>
                                <li>Athlete and Celebrity Endorsements</li>
                                <li>Reality TV Contracts</li>
                                <li>Privacy and Publicity Rights</li>
                                <li>Contract Review, Drafting, and Negotiation</li>
                                <li>Music Licensing</li>
                                <li>Intellectual Property Disputes</li>
                                <li>Producer Agreements and Copyright Splits</li>
                                <li>Work For Hire Agreements</li>
                                <li>New Media and Internet Law</li>
                                <li>Criminal & Civil Defense</li>
                            </ul>

                            <u>Interactive Lectures:</u>
                            <br/><br/>
                            <ul>
                                <li>What is an Entertainment Attorney? An introduction to your team: 1 hour.</li>
                                <li>What's a Manager? Your Team Part II: 1 hour on the various types of
                                    'managers' in the entertainment world.</li>
                                <li>Media Training: How to use new and old media to promote your latest project.
                                    1-2 hour program for groups of any size.</li>
                            </ul>
                            <br/><br/>
                        </Col>
                    </Row>

                </Container>
            </div>
        );
    }
}

export default Services;